'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadr';
var iconName = 'diamond-half-stroke';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e5b8';
var svgPathData = ['M48 256c0 2.6 1 5.2 2.9 7L232 444.1 232 67.9 50.9 249c-1.9 1.9-2.9 4.4-2.9 7z', 'M232 67.9L232 444.1 50.9 263c-1.9-1.9-2.9-4.4-2.9-7s1-5.2 2.9-7L232 67.9zm48 376.2L280 67.9 461.1 249c1.9 1.9 2.9 4.4 2.9 7s-1 5.2-2.9 7L280 444.1zM215 17L17 215C6.1 225.9 0 240.6 0 256s6.1 30.1 17 41L215 495c10.9 10.9 25.6 17 41 17s30.1-6.1 41-17L495 297c10.9-10.9 17-25.6 17-41s-6.1-30.1-17-41L297 17C286.1 6.1 271.4 0 256 0s-30.1 6.1-41 17z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faDiamondHalfStroke = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;